import { TbHistory } from "react-icons/tb";

import { usePlanActions, usePlanShowPassengerHistoryDialog } from "@/stores/use-plan-table";

import CommonPopup from "../CommonPopup";
import PassengerHistoryDialogContent from "./PassengerHistoryDialog";

export default function () {
    const passengerId = usePlanShowPassengerHistoryDialog();
    const { updateShowPassengerHistoryDialog } = usePlanActions();

    const onClose = () => {
        updateShowPassengerHistoryDialog();
    };

    return (
        <CommonPopup title={"Yolcu Geçmişi"} icon={TbHistory} open={!!passengerId} size="md" onClose={onClose}>
            <PassengerHistoryDialogContent />
        </CommonPopup>
    );
}
